export enum CompanyType {
	internal = "Internal",
	external = "External",
}
